export default __webpack_public_path__ + "static/media/OktatasMunkaVilaga.a19a45b3.jpg";